var rich_content_viewer_default = {
  "fontElementMap": "_0BreP",
  "wrapper": "eW1Gr",
  "pluginContainerMobile": "_7hQAC",
  "viewer": "_1bYMs",
  "android": "ekzjv",
  "rootedTraversedContent": "rRoO2",
  "atomic": "_1qgU5",
  "toolbar": "yVRjw",
  "block": "K-rEr"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
